import * as React from "react";
import GetAccessLink from "./Auth/GetAccessLink";
import { openSdaLoginDialog } from "./Auth/sdaLoginDialog";
import Microsoft from "./svg/Microsoft";
import { useAppDispatch } from "../store";

type Props = {
  isOfficeInitialized: boolean;
};

/** Access-denied screen (IQVIACBEXU-10030 — Figma screen 3, parity with unity-app-frontend). */
function AccessDenied({ isOfficeInitialized }: Props) {
  const dispatch = useAppDispatch();
  const [error, setError] = React.useState("");

  function handleSdaLogin() {
    setError("");
    openSdaLoginDialog(isOfficeInitialized, dispatch, setError);
  }

  return (
    <div className="sso-login-wrapper auth-screen">
      <div className="login-form">
        <p className="form-title">IQVIA Unity</p>
        <div className="access-denied-banner" role="alert">
          <span className="access-denied-banner__icon" aria-hidden="true" />
          <span className="access-denied-banner__message">
            <span>This account doesn&apos;t have access to </span>
            <span>Unity.</span>
          </span>
        </div>
        {error ? (
          <p className="auth-inline-error" role="alert">
            {error}
          </p>
        ) : null}
        <GetAccessLink className="get-access-help--access-denied" />
        <button
          type="button"
          className="azure-login-button azure-login-button--outline"
          onClick={handleSdaLogin}
        >
          <Microsoft width={18} height={18} variant="outline" />
          Log in with SSO
        </button>
      </div>
    </div>
  );
}

export default AccessDenied;
